export function isValidEmail(email) {
    console.log(email)
    // Регулярное выражение для проверки email адреса
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Используем метод test для проверки email на соответствие регулярному выражению
    return emailRegex.test(email);
}